module.exports = __webpack_public_path__ + "img/sds_1690-1.5cdcf915.jpg";